module.exports = __webpack_public_path__ + "img/iconHead.2c1e76ec.png";